import { computed, defineComponent, onBeforeMount, ref, watch } from '@vue/composition-api';
import { logger } from '@/utils/logger';
import { creatorStorage } from '@/utils/storage';
import MyBox from '../sub-components/box.vue';
import MyButton from '../sub-components/my-button.vue';
import { toPost } from '@/utils/ikwai';
import { sendTop100CustomLog } from '@/utils/custom-log';
export default defineComponent({
  components: {
    MyBox: MyBox,
    MyButton: MyButton
  },
  setup: function setup(props, ctx) {
    var renderList = [{
      src: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/time-2.png',
      desc: 'Duração'
    }, {
      src: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/hashtag-2.png',
      desc: 'Hashtag'
    }, {
      src: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/magic-face-2.png',
      desc: 'Filtro'
    }, {
      src: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/person-2.png',
      desc: 'Pessoa Real'
    }, {
      src: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/au-2.png',
      desc: 'Videos Originais'
    }]; // 是否已报名，query带入
    // const alreadySignQuery = getQuery('alreadySign');
    // // 只是设置成已报名，但考虑如果之前就存储过已报名，不会触发watch
    // const handleAlreadySignQuery = () => {
    //     if (alreadySignQuery) {
    //         toSign();
    //     }
    // };
    //  是否已报名

    var signType = ref('not-done'); // 保存信息

    var savesignType = function savesignType() {
      creatorStorage.set('top100_sign', signType.value);
    }; // 报名成功


    var toSign = function toSign() {
      signType.value = 'done';
    }; // 记录报名，其实就是上报埋点


    var saveSign = function saveSign() {
      logger.kwailog.sendClick({
        action: 'JOIN_BUTTON'
      });
      sendTop100CustomLog({
        event: 'clickToSign'
      });
    };

    var sendJoinLog = function sendJoinLog() {
      logger.kwailog.sendShow({
        action: 'JOIN_BUTTON'
      });
    };

    var initSignType = function initSignType() {
      var storagesignType = creatorStorage.get('top100_sign');

      if (storagesignType) {
        signType.value = storagesignType;
      }

      if (signType.value === 'not-done') {
        sendJoinLog();
      } // 只会监听从not-done到done


      watch(function () {
        return signType.value;
      }, function (newVal, oldVal) {
        // 进行报名
        if (newVal === 'done' && oldVal === 'not-done') {
          saveSign();
        }

        savesignType();
      });
    };

    onBeforeMount(function () {
      initSignType(); // handleAlreadySignQuery();
    });
    var buttonTextMap = {
      // 现在报名
      'not-done': 'Inscreva-se Agora',
      // “已报名，继续拍摄
      done: 'Inscrito, continue a postar vídeos'
    };
    var buttonText = computed(function () {
      return buttonTextMap[signType.value];
    });

    var handleClick = function handleClick() {
      toPost({
        enter_source: 'TOP100_SIGN',
        magicFaceId: 523912,
        challengeId: 1050,
        activitySource: 'kwaitop100'
      }); // 去报名

      if (signType.value === 'not-done') {
        // listenPost();
        setTimeout(function () {
          toSign();
        }, 1000);
      }
    };

    return {
      renderList: renderList,
      handleClick: handleClick,
      buttonText: buttonText,
      signType: signType
    };
  }
});